const typography = {
  fontFamily: ['Poppins', 'Oswald', 'cursive'].join(','),
  button: {
    textTransform: 'none',
  },
}

export default typography
